import { MelodyLib } from '@tunasong/music-lib'
import type { Melody } from '@tunasong/schemas'

/**
 * The decision behind MIDI and on-screen-keyboard entry, without the MIDI plumbing: insert a note
 * at the cursor and advance the cursor one grid slot.
 *
 * It lives in its own module, apart from `use-melody-midi-insert.ts`, because that hook imports
 * `@tunasong/audio-ui`, whose transitive `swiped-events` import touches `window` at module scope
 * and cannot be loaded in a node-environment test. Keeping the tested decision RN-of-the-browser-
 * free means the rule can be tested without an audio stack.
 *
 * Spec: docs/superpowers/specs/2026-09-08-melody-plugin-design.md §4.1
 */

export interface MidiInsertResult {
  melody: Melody
  cursorBeats: number
}

export const midiInsert = (melody: Melody, cursorBeats: number, midi: number, velocity: number): MidiInsertResult => ({
  melody: MelodyLib.insertMelodyNote(melody, { midi, onset: cursorBeats, velocity }),
  cursorBeats: cursorBeats + MelodyLib.gridSlotBeats(melody.grid),
})
